export default {
      id: "logo-canara-usage",
      viewBox: "-8.468 -6.737 328 64.68",
      url: __webpack_public_path__ + "sprite.svg#logo-canara",
      toString: function () {
        return this.url;
      }
    }